// Post and vehicle limits
// These should match the backend configuration in backend/src/config/constants.js

// Maximum active shift posts for vehicle owners
export const MAX_SHIFT_POSTS = 5;

// Maximum active availability posts for drivers (one per shift type)
export const MAX_DRIVER_POSTS = 6;

// Maximum vehicles per vehicle owner
export const MAX_VEHICLES = 5;

// Maximum active medallion posts per user
export const MAX_MEDALLION_POSTS = 4;

// Post expiration period in days
export const POST_EXPIRY_DAYS = 30;

// Pagination
export const PAGINATION = {
  DEFAULT_LIMIT: 10,
  MAX_LIMIT: 100,
  MIN_LIMIT: 1
};
